// import animal1p from '../assets/img/animals/images/cow.png'; // Use as mockup for flex shop
// import animal2p from '../assets/img/animals/images/goat.png'; // Use as mockup for flex shop
// import animal3p from '../assets/img/animals/images/sheep.png'; // Use as mockup for flex shop
// import animal4p from '../assets/img/animals/images/pig.png'; // Use as mockup for flex shop
// import animal5p from '../assets/img/animals/images/horse.png'; // Use as mockup for flex shop
// import animal6p from '../assets/img/animals/images/donkey.png'; // Use as mockup for flex shop
// import animal7p from '../assets/img/animals/images/buffalo.png'; // Use as mockup for flex shop
// import animal8p from '../assets/img/animals/images/deer.png'; // Use as mockup for flex shop
// import animal9p from '../assets/img/animals/images/camel.png'; // Use as mockup for flex shop
// import animal10p from '../assets/img/animals/images/moose.png'; // Use as mockup for flex shop
// import animal11p from '../assets/img/animals/images/yak.png'; // Use as mockup for flex shop
// import animal12p from '../assets/img/animals/images/golden.png'; // Use as mockup for flex shop
// import animal13p from '../assets/img/animals/images/alpaca.png'; // Use as mockup for flex shop

// import animal1 from '../assets/img/animals/gifs/cow.gif'; // Use as mockup for flex shop
// import animal2 from '../assets/img/animals/gifs/goat.gif'; // Use as mockup for flex shop
// import animal3 from '../assets/img/animals/gifs/sheep.gif'; // Use as mockup for flex shop
// import animal4 from '../assets/img/animals/gifs/pig.gif'; // Use as mockup for flex shop
// import animal5 from '../assets/img/animals/gifs/horse.gif'; // Use as mockup for flex shop
// import animal6 from '../assets/img/animals/gifs/donkey.gif'; // Use as mockup for flex shop
// import animal7 from '../assets/img/animals/gifs/buffalo.gif'; // Use as mockup for flex shop
// import animal8 from '../assets/img/animals/gifs/deer.gif'; // Use as mockup for flex shop
// import animal9 from '../assets/img/animals/gifs/camel.gif'; // Use as mockup for flex shop
// import animal10 from '../assets/img/animals/gifs/moose.gif'; // Use as mockup for flex shop
// import animal11 from '../assets/img/animals/gifs/yak.gif'; // Use as mockup for flex shop
// import animal12 from '../assets/img/animals/gifs/golden.gif'; // Use as mockup for flex shop
// import animal13 from '../assets/img/animals/gifs/alpaca.gif'; // Use as mockup for flex shop

// import Room1 from '../assets/img/facilities/barn_1.png'; // Use as mockup for flex shop
// import Room2 from '../assets/img/facilities/barn_2.png'; // Use as mockup for flex shop
// import Room3 from '../assets/img/facilities/barn_3.png'; // Use as mockup for flex shop
// import Room4 from '../assets/img/facilities/barn_4.png'; // Use as mockup for flex shop
// import Room5 from '../assets/img/facilities/barn_5.png'; // Use as mockup for flex shop
// import Room6 from '../assets/img/facilities/barn_6.png'; // Use as mockup for flex shop

// import flexshop1 from '../assets/img/flexshop/images/hopiumpump.png'; // Use as mockup for flex shop
// import flexshop2 from '../assets/img/flexshop/images/mcdonaldslogo.png'; // Use as mockup for flex shop
// import flexshop3 from '../assets/img/flexshop/images/pepecowboy.png'; // Use as mockup for flex shop
// import flexshop4 from '../assets/img/flexshop/images/weedcup.png'; // Use as mockup for flex shop
// import flexshop5 from '../assets/img/flexshop/images/fantomstatue.png'; // Use as mockup for flex shop
// import flexshop6 from '../assets/img/flexshop/images/acfarmer.png'; // Use as mockup for flex shop
// import flexshop7 from '../assets/img/flexshop/images/buttplug.png'; // Use as mockup for flex shop

// import flexshop8 from '../assets/img/flexshop/images/buttplug_field.png'; // Use as mockup for flex shop
// import flexgif1 from '../assets/img/flexshop/gifs/acfarmer.gif'; // Use as mockup for flex shop
// import flexgif2 from '../assets/img/flexshop/gifs/mcdonaldslogo.gif'; // Use as mockup for flex shop
// import flexgif3 from '../assets/img/flexshop/gifs/pepecowboy.gif'; // Use as mockup for flex shop

// import mysteryBoxAnimals from '../assets/img/mystery/animal_mystery.png';
// import mysteryBoxFlexshop from '../assets/img/mystery/flexshop_mystery.png';
// import mysteryBoxMix from '../assets/img/mystery/mix_mystery.png';

// import mysteryBoxAnimalsOpen from '../assets/img/mystery/open/open_animal_mystery.png';
// import mysteryBoxFlexshopOpen from '../assets/img/mystery/open/open_flexshop_mystery.png';
// import mysteryBoxMixOpen from '../assets/img/mystery/open/open_mix_mystery.png';

const mysteryBoxAnimals = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/mystery/animal_mystery.png';
const mysteryBoxFlexshop = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/mystery/flexshop_mystery.png';
const mysteryBoxMix = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/mystery/mix_mystery.png';

const mysteryBoxAnimalsOpen = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/mystery/open/open_animal_mystery.png';
const mysteryBoxFlexshopOpen = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/mystery/open/open_flexshop_mystery.png';
const mysteryBoxMixOpen = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/mystery/open/open_mix_mystery.png';

const animal1p = "https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/cow.png"
const animal2p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/goat.png'; // Use as mockup for flex shop
const animal3p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/sheep.png'; // Use as mockup for flex shop
const animal4p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/pig.png'; // Use as mockup for flex shop
const animal5p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/horse.png'; // Use as mockup for flex shop
const animal6p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/donkey.png'; // Use as mockup for flex shop
const animal7p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/buffalo.png'; // Use as mockup for flex shop
const animal8p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/deer.png'; // Use as mockup for flex shop
const animal9p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/camel.png'; // Use as mockup for flex shop
const animal10p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/moose.png'; // Use as mockup for flex shop
const animal11p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/yak.png'; // Use as mockup for flex shop
const animal12p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/golden.png'; // Use as mockup for flex shop
const animal13p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/alpaca.png'; // Use as mockup for flex shop
const animal14p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/unicorn.png'; // Use as mockup for flex shop
const animal15p = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/images/milkacow.png'; // Use as mockup for flex shop


const animal1 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/cow.gif'; // Use as mockup for flex shop
const animal2 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/goat.gif'; // Use as mockup for flex shop
const animal3 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/sheep.gif'; // Use as mockup for flex shop
const animal4 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/pig.gif'; // Use as mockup for flex shop
const animal5 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/horse.gif'; // Use as mockup for flex shop
const animal6 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/donkey.gif'; // Use as mockup for flex shop
const animal7 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/buffalo.gif'; // Use as mockup for flex shop
const animal8 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/deer.gif'; // Use as mockup for flex shop
const animal9 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/camel.gif'; // Use as mockup for flex shop
const animal10 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/moose.gif'; // Use as mockup for flex shop
const animal11 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/yak.gif'; // Use as mockup for flex shop
const animal12 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/golden.gif'; // Use as mockup for flex shop
const animal13 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/alpaca.gif'; // Use as mockup for flex shop
const animal14 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/unicorn.gif'; // Use as mockup for flex shop
const animal15 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/animals/gifs/milkacow_1.gif'; // Use as mockup for flex shop

const Room1 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_1.png'; // Use as mockup for flex shop
const Room2 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_2.png'; // Use as mockup for flex shop
const Room3 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_3.png'; // Use as mockup for flex shop
const Room4 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_4.png'; // Use as mockup for flex shop
const Room5 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_5.png'; // Use as mockup for flex shop
const Room6 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_6.png'; // Use as mockup for flex shop
const Room7 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/facilities/barn_7.png'; // Use as mockup for flex shop

const flexshop1 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/hopiumpump.png'; // Use as mockup for flex shop
const flexshop2 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/mcdonaldslogo.png'; // Use as mockup for flex shop
const flexshop3 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/pepecowboy.png'; // Use as mockup for flex shop
const flexshop4 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/weedcup.png'; // Use as mockup for flex shop
const flexshop5 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/fantomstatue.png'; // Use as mockup for flex shop
const flexshop6 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/acfarmer.png'; // Use as mockup for flex shop
const flexshop7 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/buttplug.png'; // Use as mockup for flex shop

const flexshop8 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/buttplug_field.png'; // Use as mockup for flex shop
const flexshop9 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/snake.png'; // Use as mockup for flex shop
const flexshop10 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/handofgod.png'; // Use as mockup for flex shop
const flexshop11 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/shadow.png'; // Use as mockup for flex shop
const flexshop12 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/ecologist.png'; // Use as mockup for flex shop
const flexshop13 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/images/siesta.png'; // Use as mockup for flex shop

const flexgif1 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/gifs/acfarmer.gif'; // Use as mockup for flex shop
const flexgif2 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/gifs/mcdonaldslogo.gif'; // Use as mockup for flex shop
const flexgif3 = 'https://raw.githubusercontent.com/MilkItFinance/milkit-assets/refs/heads/main/flexshop/gifs/pepecowboy.gif'; // Use as mockup for flex shop

export const BIGCOINTOKEN_ADDRESS = "0xA052cC4dD2138504Dd89E723D72636D491b4cEd9"
export const BIGCOINMAIN_ADDRESS = "0xe831169D300B6f28e5d0cE1f3f8655a091504A48"
export const MACROSTRATEGY_TRANCHE_A_ADDRESS = "0x7818561e823C185a8E3F381Ee3e15855510d29aF"
export const MILK_ORACLE_ADDRESS = "0x5120C2a2Dac51454Ba7Aa00F139bd89AE8B0939C"

export const MISTERY_BOX_ADDRESS = "0xD619D054ef5e9A48505F00028c18cfC0802fEC98";


export const TOKEN_SYMBOL = "MILK"

export const CLAIM_SLIPPAGE = 1.05;

export const TOTAL_BARNS = 7;

export const RoomProperties: { [key: number]: { id: number; name: string; maxMiners: number; maxPower: number; cost: number; description: string; img: string; x: number; y: number } } = {
  1: { id: 1, name: "Hay Barn", img: Room1, maxMiners: 4, maxPower: 28, cost: 100, description: "Small hay capacity", x: 2, y: 2 },
  2: { id: 2, name: "Tool Barn", img: Room2, maxMiners: 8, maxPower: 168, cost: 210, description: "Complaints from animals", x: 2, y: 4 },
  3: { id: 3, name: "Supply Barn", img: Room3, maxMiners: 12, maxPower: 420, cost: 1125, description: "Helps you produce more", x: 3, y: 4 },
  4: { id: 4, name: "Comfy Barn", img: Room4, maxMiners: 16, maxPower: 1120, cost: 888, description: "Who says animals are not comfy?", x: 4, y: 4 },
  5: { id: 5, name: "Tech Barn", img: Room5, maxMiners: 20, maxPower: 7000, cost: 1065, description: "Robotic animals allowed", x: 4, y: 5 },
  6: { id: 6, name: "Space Barn", img: Room6, maxMiners: 20, maxPower: 13125, cost: 1275, description: "Conquered the art of space farming", x: 4, y: 5 },
  7: { id: 7, name: "Casino Barn", img: Room7, maxMiners: 20, maxPower: 19685, cost: 2550, description: "Gambling my cows for more milk", x: 4, y: 5 },
}

export const startTileOffsets: Record<number, { x: number; y: number }> = {
  1: { x: 280, y: 325 }, // Bedroom
  2: { x: 270, y: 290 }, // Garage (adjust as needed)
  3: { x: 310, y: 270 }, // Shed
  4: { x: 355, y: 260 }, // Room 3: large grid, minimal margin
  5: { x: 320, y: 240 }, // Room 4: a little bigger
  6: { x: 320, y: 235 },
  7: { x: 320, y: 235 },
};

export const tileWidthByRoom: Record<number, number> = { 3: 155, 4: 140, 5: 130, 6: 130, 7: 130 };
export const tileHeightByRoom: Record<number, number> = { 3: 85, 4: 70, 5: 70, 6: 70, 7: 70 };

export const canvasWidth = 770;
export const canvasHeight = 640;

export const roomDrawParams: Record<number, { x: number; y: number; w: number; h: number }> = {
  0: { x: 70, y: 60, w: canvasWidth - 140, h: canvasHeight - 120 }, // Bedroom
  1: { x: 70, y: 50, w: canvasWidth - 120, h: canvasHeight - 100 }, // Garage (smaller)
  2: { x: 60, y: 40, w: canvasWidth - 120, h: canvasHeight - 80 },   // Shed
  3: { x: 45, y: 40, w: canvasWidth - 90, h: canvasHeight - 105 }, // Room 3: a little bigger
  4: { x: 45, y: 40, w: canvasWidth - 90, h: canvasHeight - 105 }, // Room 3: a little bigger
  5: { x: 45, y: 40, w: canvasWidth - 90, h: canvasHeight - 105 }, // Room 4: a little bigger
  6: { x: 45, y: 40, w: canvasWidth - 90, h: canvasHeight - 105 }, // Room 5: a little bigger
  7: { x: 45, y: 40, w: canvasWidth - 90, h: canvasHeight - 105 }, // Room 5: a little bigger
};

export interface Miner {
  id: number;
  name: string;
  img: string;
  gif: string;
  hashRate: number;
  price: number;
  energy: number;
  description: string;
  availableToBuy: boolean;
  isFlex: boolean;
}

export const miners: Miner[] = [
  { id: 1, name: 'COW', img: animal1p, gif: animal1, hashRate: 100, price: 0, energy: 1, description: ``, availableToBuy: false, isFlex: false },
  { id: 2, name: 'GOAT', img: animal2p, gif: animal2, hashRate: 180, price: 21, energy: 6, description: ``, availableToBuy: true, isFlex: false },
  { id: 3, name: 'SHEEP', img: animal3p, gif: animal3, hashRate: 420, price: 36, energy: 8, description: ``, availableToBuy: true, isFlex: false },
  { id: 4, name: 'PIG', img: animal4p, gif: animal4, hashRate: 720, price: 54, energy: 10, description: ``, availableToBuy: true, isFlex: false },
  { id: 5, name: 'HORSE', img: animal5p, gif: animal5, hashRate: 1000, price: 60, energy: 10, description: ``, availableToBuy: true, isFlex: false },
  { id: 6, name: 'DONKEY', img: animal6p, gif: animal6, hashRate: 5000, price: 180, energy: 30, description: ``, availableToBuy: true, isFlex: false },
  { id: 7, name: 'BUFFALO', img: animal7p, gif: animal7, hashRate: 15000, price: 375, energy: 50, description: ``, availableToBuy: true, isFlex: false },
  { id: 8, name: 'DEER', img: animal8p, gif: animal8, hashRate: 20000, price: 600, energy: 90, description: ``, availableToBuy: true, isFlex: false },
  { id: 9, name: 'CAMEL', img: animal9p, gif: animal9, hashRate: 60000, price: 1200, energy: 200, description: ``, availableToBuy: true, isFlex: false },
  { id: 10, name: 'MOOSE', img: animal10p, gif: animal10, hashRate: 200000, price: 3600, energy: 600, description: ``, availableToBuy: true, isFlex: false },
  { id: 27, name: 'MILKA COW', img: animal15p, gif: animal15, hashRate: 1120000, price: 8000, energy: 3200, description: '', availableToBuy: true, isFlex: false },
  { id: 11, name: 'YAK', img: animal11p, gif: animal11, hashRate: 800000, price: 9000, energy: 2000, description: ``, availableToBuy: true, isFlex: false },
  { id: 12, name: 'GOLDEN COW', img: animal12p, gif: animal12, hashRate: 1336000, price: 12000, energy: 3000, description: '', availableToBuy: true, isFlex: false },
  { id: 13, name: 'ALPACA', img: animal13p, gif: animal13, hashRate: 2508000, price: 18000, energy: 5000, description: '', availableToBuy: true, isFlex: false },
  { id: 26, name: 'UNICORN', img: animal14p, gif: animal14, hashRate: 3484000, price: 28000, energy: 4500, description: '', availableToBuy: true, isFlex: false },

  { id: 14, name: 'HOPIUM PUMP', img: flexshop1, gif: flexshop1, hashRate: 0, price: 15, energy: 0, description: 'REEEEEE JUST ONE MORE HIT', availableToBuy: true, isFlex: true },
  { id: 15, name: 'GOLD ARCH', img: flexshop2, gif: flexgif2, hashRate: 0, price: 15, energy: 0, description: 'MY JOB IF I GO ALL IN', availableToBuy: true, isFlex: true },
  { id: 16, name: 'PEPE COWBOY', img: flexshop3, gif: flexgif3, hashRate: 0, price: 30, energy: 0, description: 'Yeehaw! FOR THE CRYPTO OGS', availableToBuy: true, isFlex: true },
  { id: 17, name: 'WEED POT', img: flexshop4, gif: flexshop4, hashRate: 1, price: 30, energy: 0, description: 'Puff a day keeps the doctor away', availableToBuy: true, isFlex: true },
  { id: 18, name: 'FANTOM STATUE', img: flexshop5, gif: flexshop5, hashRate: 0, price: 60, energy: 0, description: 'REMEMBER OLD TIMES', availableToBuy: true, isFlex: true },
  { id: 20, name: 'BUTTPLUG', img: flexshop7, gif: flexshop8, hashRate: 0, price: 1000, energy: 0, description: 'Secret Performance Booster', availableToBuy: true, isFlex: true },
  { id: 19, name: 'A.C FARMER', img: flexshop6, gif: flexgif1, hashRate: 1, price: 3000, energy: 0, description: 'Calm and yieldin’ while you sweat', availableToBuy: true, isFlex: true },
  { id: 21, name: 'SNAKE', img: flexshop9, gif: flexshop9, hashRate: 0, price: 10, energy: 0, description: 'Slithering into the future', availableToBuy: true, isFlex: true },
  { id: 22, name: 'HAND OF GOD', img: flexshop10, gif: flexshop10, hashRate: 0, price: 10, energy: 0, description: 'The hand of god', availableToBuy: true, isFlex: true },
  { id: 23, name: 'SHADOW PODIUM', img: flexshop11, gif: flexshop11, hashRate: 0, price: 25, energy: 0, description: 'x33 Premium', availableToBuy: true, isFlex: true },
  { id: 24, name: 'ECOLOGIST', img: flexshop12, gif: flexshop12, hashRate: 0, price: 10, energy: 0, description: 'There is only one sapling', availableToBuy: true, isFlex: true },
  { id: 25, name: 'SIESTA', img: flexshop13, gif: flexshop13, hashRate: 0, price: 25, energy: 0, description: 'DEFAI? Building it', availableToBuy: true, isFlex: true },
];

export const animalCollectionData = [
  { 
    id: 1,
    name: "COW", 
    image: animal1, 
    milkRate: "100 L/S",
    price: "FREE",
    energy: "1 FOOD"
  },
  { 
    id: 2,
    name: "GOAT", 
    image: animal2, 
    milkRate: "180 L/S",
    price: "21 $MILK",
    energy: "6 FOOD"
  },
  { 
    id: 3,
    name: "SHEEP", 
    image: animal3, 
    milkRate: "420 L/S",
    price: "36 $MILK",
    energy: "8 FOOD"
  },
  { 
    id: 4,
    name: "PIG", 
    image: animal4, 
    milkRate: "720 L/S",
    price: "54 $MILK",
    energy: "10 FOOD"
  },
  { 
    id: 5,
    name: "HORSE", 
    image: animal5, 
    milkRate: "1000 L/S",
    price: "60 $MILK",
    energy: "10 FOOD"
  },
  { 
    id: 6,
    name: "DONKEY", 
    image: animal6, 
    milkRate: "5000 L/S",
    price: "180 $MILK",
    energy: "30 FOOD"
  },
  { 
    id: 7,
    name: "BUFFALO", 
    image: animal7, 
    milkRate: "15,000 L/S",
    price: "375 $MILK",
    energy: "50 FOOD"
  },
  { 
    id: 8,
    name: "DEER", 
    image: animal8, 
    milkRate: "20,000 L/S",
    price: "600 $MILK",
    energy: "90 FOOD"
  },
  { 
    id: 9,
    name: "CAMEL", 
    image: animal9, 
    milkRate: "60,000 L/S",
    price: "1200 $MILK",
    energy: "200 FOOD"
  },
  { 
    id: 10,
    name: "MOOSE", 
    image: animal10, 
    milkRate: "200,000 L/S",
    price: "3600 $MILK",
    energy: "600 FOOD"
  },
  { 
    id: 27,
    name: "Milka Cow", 
    image: animal15, 
    milkRate: "1,120,000 L/S",
    price: "8000 $MILK",
    energy: "3200 FOOD"
  },
  { 
    id: 11,
    name: "YAK", 
    image: animal11, 
    milkRate: "800,000 L/S", 
    price: "9000 $MILK",
    energy: "2000 FOOD"
  },
  { 
    id: 12,
    name: "GOLDEN COW", 
    image: animal12, 
    milkRate: "1,336,000 L/S",
    price: "12000 $MILK",
    energy: "3000 FOOD"
  },
  { 
    id: 13,
    name: "Alpaca", 
    image: animal13, 
    milkRate: "2,508,000 L/S",
    price: "18000 $MILK",
    energy: "5000 FOOD"
  },
  { 
    id: 26,
    name: "Unicorn", 
    image: animal14, 
    milkRate: "3,484,000 L/S",
    price: "28000 $MILK",
    energy: "4500 FOOD"
  },
];

// Barn collection data
export const barnCollectionData = [
  { 
    name: "Hay Barn", 
    image: Room1, 
    maxMiners: "4",
    power: "28 FOOD"
  },
  { 
    name: "Tool Barn", 
    image: Room2, 
    maxMiners: "8",
    power: "168 FOOD"
  },
  { 
    name: "Supply Barn", 
    image: Room3, 
    maxMiners: "12",
    power: "420 FOOD"
  },
  { 
    name: "Comfy Barn", 
    image: Room4, 
    maxMiners: "16",
    power: "1120 FOOD"
  },
  { 
    name: "Tech Barn", 
    image: Room5, 
    maxMiners: "20",
    power: "7000 FOOD"
  },
  { 
    name: "Space Barn", 
    image: Room6, 
    maxMiners: "20",
    power: "13125 FOOD"
  },
  { 
    name: "Casino Barn", 
    image: Room7, 
    maxMiners: "20",
    power: "19685 FOOD"
  }
];

export const flexItemsData = [
  { name: "HOPIUM PUMP", image: flexshop1, price: "15 $MILK"},
  { name: "GOLD ARCH", image: flexshop2, price: "15 $MILK"},
  { name: "PEPE COWBOY", image: flexshop3, price: "30 $MILK"},
  { name: "WEED POT", image: flexshop4, price: "30 $MILK"},
  { name: "FANTOM STATUE", image: flexshop5, price: "60 $MILK"},
  { name: "BUTTPLUG", image: flexshop7, price: "1000 $MILK"},
  { name: "A.C FARMER", image: flexshop6, price: "3000 $MILK"},
  { name: "SNAKE", image: flexshop9, price: "10 $MILK"},
  { name: "HAND OF GOD", image: flexshop10, price: "10 $MILK"},
  { name: "SHADOW PODIUM", image: flexshop11, price: "25 $MILK"},
  { name: "ECOLOGIST", image: flexshop12, price: "10 $MILK"},
  { name: "SIESTA", image: flexshop13, price: "25 $MILK"},
];

export const MYSTERY_BOXES = [
  {
    id: 1,
    type: 'animals',
    title: 'Animals Mystery Box',
    image: mysteryBoxAnimals,
    openImage: mysteryBoxAnimalsOpen,
    price: 150,
    emoji: '🐾',
    prizes: [1,2,3,4,5,6,7,8,9,10,11,12,13,14],
    probabilities: [3903433,2277003,1518002,1366202,455401,218592,136620,68310,22770,10246,9108,6831,4554,2928]
  },
  {
    id: 2,
    type: 'flexshop',
    title: 'FlexShop Mystery Box',
    image: mysteryBoxFlexshop,
    openImage: mysteryBoxFlexshopOpen,
    price: 25,
    emoji: '🛍️',
    prizes: [15,16,17,18,19,20,21,22,23,24,25,26],
    probabilities: [1114827,1114827,557414,557414,278707,16722,5574,1672241,1672241,668896,1672241,668896]
  },
  {
    id: 3,
    type: 'mix',
    title: 'Mix Mystery Box',
    image: mysteryBoxMix,
    openImage: mysteryBoxMixOpen,
    price: 50,
    emoji: '🎲',
    prizes: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26],
    probabilities: [661383,385806,257204,231484,77161,37037,23148,11574,3858,1736,1543,1158,772,496,925935,925935,462968,462968,231484,13889,4630,1388903,1388903,555561,1388903,555561]
  },
];

export const MYSTERY_BOXES_PRIZES: Record<number, Miner> = {
  1: miners[1],
  2: miners[2],
  3: miners[3],
  4: miners[4],
  5: miners[5],
  6: miners[6],
  7: miners[7],
  8: miners[8],
  9: miners[9],
  10: miners[10],
  11: miners[11],
  12: miners[12],
  13: miners[13],
  14: miners[14],
  15: miners[15],
  16: miners[16],
  17: miners[17],
  18: miners[18],
  19: miners[19],
  20: miners[20],
  21: miners[21],
  22: miners[22],
  23: miners[23],
  24: miners[24],
  25: miners[25],
  26: miners[26],
}


